import { PropsWithChildren, ReactNode } from 'react'

import GenericErrorAlert from '../molecules/generic-error-alert'
import { GenericListSkeleton } from '../molecules/generic-skeletons'

type ErrorProps =
  | {
      errorState?: ReactNode
      isError: boolean
    }
  | {
      errorState?: never
      isError?: false
    }

type LoadingProps =
  | {
      isLoading: boolean
      loadingState?: ReactNode
    }
  | {
      isLoading?: false
      loadingState?: never
    }

type EmptyProps =
  | {
      emptyState: ReactNode
      isEmpty: boolean
    }
  | {
      emptyState?: never
      isEmpty?: false
    }

type Props = ErrorProps & LoadingProps & EmptyProps

const StateSwitcher = ({
  children,
  emptyState,
  errorState = <GenericErrorAlert />,
  isEmpty,
  isError,
  isLoading,
  loadingState = <GenericListSkeleton />,
}: PropsWithChildren<Props>) => {
  if (isLoading) return loadingState
  if (isError) return errorState
  if (isEmpty) return emptyState

  return children
}

export { StateSwitcher }
